import Backbone from 'backbone'
import template from './alert-preferences.hbs'
import i18n from 'scoreboard/components/i18n'
import DisplayHeader from 'scoreboard/components/display-header'
import NotificationPreferences from './notification-preferences'
import AlertSubscriptions from './alert-subscriptions'

/**
 * The Admin | Alert Preferences | Email Preferences panel
 */
var AlertPreferences = Backbone.View.extend({

	tagName: 'form',

	className: 'admin table-hack display-layout alert-preferences',

	// this.data is the response from SubscriptionsController.get
	initialize: function(options) {
		this.data = options.data
	},

	render: function() {
		this.$el.empty().append(new DisplayHeader({
			heading: i18n.get('admin.personal.alertPreferences'),
			mobileGearHidden: true
		}).render().el, template())

		const alertSubscriptions = new AlertSubscriptions({ data: this.data })
		this.$('.notification-preferences').after(alertSubscriptions.el)
		alertSubscriptions.render()

		const notificationPreferences = new NotificationPreferences({ data: this.data })
		this.$('.notification-preferences .panel-content').append(
			notificationPreferences.el)
		notificationPreferences.render()

		return this
	},

	autoRemove: true

})

export default AlertPreferences

AlertPreferences.__filename__ = 'admin/alerts/alert-preferences.js'
